module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/transaction-view/transaction-view.component.scss
// module id = ./src/app/routes/transaction-view/transaction-view.component.scss
// module chunks = 9